import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';

import deviceActions from '@state/device/actions';
import devicesApi from '@api/devicesApi';
import getColumns from './columns';

function useGateway() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const abortController = useRef(null);
  const unmountcomponent = useRef(true);
  // const timeoutRef = useRef();
  const timerLopping = useRef();
  const initPagination = useRef({ current: 1, pageSize: 20 });
  const history = useHistory();
  const search = '';
  const [valueFilter, setValueFilter] = useState('');
  // const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [gateway, setGateway] = useState([]);

  const [pag, setPagination] = useState(initPagination.current);

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const abortLastRequest = useCallback(() => {

    if (abortController.current) {

      abortController.current.abort();
      abortController.current = null;

    }

  }, []);

  const handleTableChange = useCallback( // load device data
    (pagination, filter, sorter) => {

      const { id: client } = clientTarget;
      const { current, pageSize: limit } = pagination;
      const offset = (current - 1) * limit;

      const { columnKey, order } = sorter || {};
      const ordering = columnKey ? `${order === 'descend' ? '-' : ''}${columnKey}` : undefined;

      abortController.current = new AbortController();
      const { signal } = abortController.current;

      setLoading(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);

      // CONSULTO LOS GATEWAY
      devicesApi
        .getAllGateway({
          client, offset, limit, ordering, search, signal,
        })
        .then(async (response) => {

          if (unmountcomponent) {

            const resp = {
              count: response.lenght,
              results: response,
            };
              // eslint-disable-next-line no-shadow
            const { results: gateway, count: total } = resp;
            setPagination({ ...pagination, total });

            const newGateways = await Promise.all(gateway.map(async (obj) => {

              const firmware_name = obj?.firmware?.fw_url;
              const item = {
                ...obj,
                firmware_name,
              };
              return item;

            }));

            setGateway(newGateways);
            setLoading(false);

            timerLopping.current = setTimeout(
              () => handleTableChange({ pagination, filter, sorter }),
              120000,
            );

          }

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

    },
    [clientTarget, search, t],
  );

  useEffect( // mount component
    () => {

      handleTableChange(initPagination.current);
      return abortLastRequest;

    },
    // eslint-disable-next-line
    []
  );

  const createGateway = useCallback( // Go to create /crear-dispositivo
    () => {

      history.push('/dispositivos/gateway/crear-gateway');

    },
    [history],
  );

  const deleteGateway = useCallback((e) => { // Delete Gateway by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;

    devicesApi.deleteGatewayById({ signal, id })
      .then((response) => {

        if (unmountcomponent) {

          message.success(t('views.create_gateway.form.remove_success'));
          handleTableChange(initPagination.current);

        }

      })
      .catch((resError) => {

        message.error(resError?.data?.detail || t('views.create_gateway.form.remove_failed'));

      });

  // eslint-disable-next-line
  }, []);

  const editGateway = useCallback((e) => { // edit Gateway, save data device in redux

    const defaultData = {
      ...e,
      fw_assigned_id: e?.firmware?.id || '',
      baud: `${e?.baud}` || '',
      ival: `${e?.ival}` || '',
      device_api_key_id: [],
      busines_id: e.business_type_id,
    };

    dispatch(deviceActions.setGatewayIdEdit(e.id));
    dispatch(deviceActions.setCreateEditGateway(defaultData));
    history.push('/dispositivos/gateway/editar-gateway');

  }, [dispatch, history]);

  const columns = useMemo(
    () => getColumns(t, deleteGateway, editGateway, currentUser),
    [t, deleteGateway, editGateway, currentUser],
  );

  const arrayFilter = gateway.filter((data) => ( // Filter by client
    data.name.toUpperCase().includes(valueFilter.toUpperCase())
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  useEffect(() => () => {

    unmountcomponent.current = false;
    clearTimeout(timerLopping.current);

  });

  return {
    setValueFilter,
    handleTableChange,
    loading,
    arrayFilter,
    gateway,
    columns,
    pagination: pag,
    createGateway,
    isCreate,
    // onChangeSearch,
  };

}

export default useGateway;
